<p-toast position="bottom-right"></p-toast>

<p-dialog
    [(visible)]="displayDialog"
    [style]="{ width: '500px' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="onDialogClosed()"
    [header]="selectedCapturista ? 'Editar Capturista' : 'Nuevo Capturista'"
    [closeOnEscape]="true"
    [closable]="true"
>
    <app-capturista-form 
        *ngIf="displayDialog"
        [model]="selectedCapturista" 
        (onSave)="onSave($event)"
    ></app-capturista-form>
</p-dialog>

<div class="card-white">
  <div class="card-header mb-4">
    <div class="title-section">
      <h2 class="header-title">Capturistas</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <span class="p-input-icon-left search-input">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt?.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Buscar..."
            class="p-inputtext-sm"
          appPermissionControl="P219K0001">
        </span>
        <button mat-flat-button (click)="openCreate()" class="btn-new" appPermissionControl="P219B0001">
          <mat-icon>add</mat-icon>
          Nuevo
        </button>
      </div>
    </div>
  </div>

  <p-table
    #dt
    [value]="dataSource" 
    [columns]="displayedColumns"
    [paginator]="true" 
    [rows]="rows"
    [first]="first"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 10, 20]"
    [scrollable]="true"
    [scrollHeight]="'calc(100vh - 400px)'"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [loading]="loading"
    [globalFilterFields]="['susuario','nombre']"
    (onPage)="onPage($event)"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
   appPermissionControl="P219T0001">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P219C0001">
          {{ col.header }}
          <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td *ngFor="let col of displayedColumns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex gap-2 justify-content-center">
                <button
                  pButton
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-info p-button-text"
                  (click)="openUpdate(rowData)"
                  pTooltip="Editar"
                 appPermissionControl="P219B0002"></button>
                <button
                  pButton
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  (click)="openDelete(rowData)"
                  pTooltip="Eliminar"
                 appPermissionControl="P219B0003"></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center td-prime">
          <span *ngIf="dataSource.length === 0 && !loading">No hay datos para mostrar</span>
          <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div> 